module.exports = __webpack_public_path__ + "c-4.c6d9ce677c1256919761.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/auth/src/assets/c-4.svg
// module id = 1490
// module chunks = 2